import { render, staticRenderFns } from "./historical-order-inquiry.vue?vue&type=template&id=6daf0bb8&scoped=true&"
import script from "./historical-order-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-order-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-order-inquiry.vue?vue&type=style&index=0&id=6daf0bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf0bb8",
  null
  
)

export default component.exports